import { Affix, Button, Group, Paper, Text, Transition } from '@mantine/core'

export default function CatalogSaveBar({
  changeCount,
  onDiscard,
  onSubmit,
}: {
  changeCount: number
  onDiscard: () => void
  onSubmit: () => void
}) {
  return (
    <Affix position={{ bottom: 24, left: '50%' }} zIndex={200}>
      <Transition transition="slide-up" mounted={changeCount > 0} duration={200}>
        {(styles) => (
          <Paper shadow="xl" radius="xl" p="sm" withBorder style={{ ...styles, transform: 'translateX(-50%)' }}>
            <Group gap="md" align="center" px="md" wrap="nowrap">
              <Text size="sm" fw={500}>
                {changeCount} modification{changeCount > 1 ? 's' : ''} non enregistrée
                {changeCount > 1 ? 's' : ''}
              </Text>
              <Button variant="subtle" color="gray" size="sm" onClick={onDiscard}>
                Annuler
              </Button>
              <Button size="sm" onClick={onSubmit}>
                Enregistrer le catalogue
              </Button>
            </Group>
          </Paper>
        )}
      </Transition>
    </Affix>
  )
}
